import { useRouter } from 'next/router';
import { useEffect, useState, type MutableRefObject } from 'react';

import { useBreakpoints } from '@/core/tamagoshi/MediaQuery/MediaQuery';

export const useShowStickyElements = (
  ref: MutableRefObject<HTMLDivElement | null>,
) => {
  const router = useRouter();
  const { xs, sm } = useBreakpoints();
  const [showStickyA2C, setShowStickyA2C] = useState<boolean>(false);
  const hasSticky = xs || sm;

  const routeChangeComplete = () => {
    setShowStickyA2C(false);
  };

  // NOTE Next is configured to restore the user's scroll position on route
  //      change but this is not captured by the interserction observer.
  useEffect(() => {
    if (hasSticky) {
      router.events.on('routeChangeComplete', routeChangeComplete);
      return () => {
        router.events.off('routeChangeComplete', routeChangeComplete);
      };
    }
  });

  useEffect(() => {
    if (hasSticky && ref.current) {
      const addToCartButton = ref.current;
      const onIntersection = (entries: IntersectionObserverEntry[]) => {
        const entry = entries[0];
        // NOTE Display the sticky elements when the top of the non-sticky A2C button reaches the top of the viewport.
        if (entry.boundingClientRect.top < 0) {
          setShowStickyA2C(true);
          // NOTE Hide the sticky A2C button when the top of the non-sticky A2C button appears in the viewport.
        } else if (entry.boundingClientRect.top > 0) {
          setShowStickyA2C(false);
        }
      };
      const observer = new IntersectionObserver(onIntersection, {
        threshold: 1,
      });
      observer.observe(addToCartButton);

      return () => {
        observer.unobserve(addToCartButton);
      };
    }
  }, [hasSticky, ref]);

  return { showStickyA2C };
};
